import { type ReactNode } from "react";
import styles from "./ProfileFieldsGroup.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";

interface ProfileFieldsGroupProps {
  children: ReactNode;
  className?: string;
}

export default function ProfileFieldsGroup({
  children,
  className,
}: ProfileFieldsGroupProps) {
  return <div className={classnames(styles.fields, className)}>{children}</div>;
}
